export default __webpack_public_path__ + "static/media/logo-01.ac51929a.png";